import { createApiClient } from '../../api/helpers.ts'
import { env } from '../../env.ts'

export const AnalyzeApi = createApiClient({ prefixUrl: env.API_ANALYZE })

type Page<T> = { items: T[]; nextToken?: string }

export const getAllPages = async <T>(path: string, searchParams: Record<string, string> = {}): Promise<T[]> => {
	const items: T[] = []
	let nextToken: string | undefined
	do {
		const page = await AnalyzeApi.get(path, { searchParams: nextToken ? { ...searchParams, nextToken } : searchParams }).json<Page<T>>()
		items.push(...page.items)
		nextToken = page.nextToken
	} while (nextToken)
	return items
}
